const module = {
  config: {
    name: "Utilities",
    icon: "settings",
    desc: "Data pendukung operasional sistem pada Aplikasi",
    layout: true,
    order: 4
  },
  routes: [
    // utility-activities
    {
      name: 'utility-activities',
      icon: 'map-pin-user-line',
      path: '/utility-activities',
      translate_key: 'utility-activities',
      component: '',
      separator: ""
    },
    // area-management
    {
      name: 'utility-area-management',
      icon: 'map-pin-line',
      path: '/utility-area-management',
      translate_key: 'utility-area-management',
      component: () => import('./area-management/area-management.vue'),
      separator: ""
    },
    {
      name: 'position-project-organization',
      icon: 'swap-2-line',
      path: '/position-project-organization',
      translate_key: 'position-project-organization',
      component: () => import('./position-project-organization/position-project-organization.vue'),
      separator: ""
    },
    // tree-models
    {
      name: 'tree-models',
      icon: 'plant',
      path: '/tree-models',
      translate_key: 'tree-models',
      component: () => import('./tree-models/tree-models.vue'),
      separator: ""
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/utilities/_index.js